import {useEffect, useState} from 'react'
import {useProducts} from '@salesforce/commerce-sdk-react'
import {getAutoSash, handleCounts, getSashForMasterAndOtherProducts} from '../utils/product-utils'

const useProductSashes = (product) => {
    const [sashes, setSashes] = useState([])

    const variationsIDS = product?.type?.master
        ? product?.variants?.map((variant) => variant.productId).join(',') ?? ''
        : product?.id

    const {data: productDataResponse} = useProducts({
        parameters: {
            ids: variationsIDS,
            perPricebook: true,
            allImages: true
        }
    })

    useEffect(() => {
        if (!productDataResponse) return

        const isMaster = product?.type?.master
        const isBundle = product?.type?.bundle

        const productDetails = isMaster ? productDataResponse?.data : productDataResponse?.data?.[0]

        const isStandard =
            productDetails?.type?.item ||
            productDetails?.type?.option ||
            productDetails?.type?.variant ||
            productDetails?.type?.standard

        const productSash = productDetails?.c_tileSashes
        const today = new Date()
        const streetDate = productDetails?.c_streetDate?.trim()
            ? new Date(productDetails?.c_streetDate)
            : today
        const isComingSoon = today < streetDate

        const hideSashes = productSash
        let tempSashes = []

        const pushSash = (name, msg) => tempSashes.push({name, msg})

        if (isStandard) {
            tempSashes = getAutoSash(productDetails, isComingSoon, hideSashes === 'Coming-SOON-YES')
        } else if (isMaster && Array.isArray(productDetails)) {
            const counts = handleCounts(productDetails)
            getSashForMasterAndOtherProducts(
                counts.instock,
                counts.preOrder,
                counts.soldout,
                counts.backorder,
                tempSashes,
                productDetails,
                hideSashes,
                'master',
                isComingSoon,
                counts.onlineCount,
                pushSash
            )
        } else if (isBundle && Array.isArray(product?.bundledProducts)) {
            const counts = handleCounts(product?.bundledProducts)
            getSashForMasterAndOtherProducts(
                counts.instock,
                counts.preOrder,
                counts.soldout,
                counts.backorder,
                tempSashes,
                product?.bundledProducts,
                hideSashes,
                'bundle',
                isComingSoon,
                counts.onlineCount,
                pushSash
            )
        }

        if (productDetails?.c_exclusiveSash && tempSashes.length < 2) {
            pushSash('sale', 'EXCLUSIVE')
        }

        setSashes(tempSashes)
    }, [productDataResponse])

    return {sashes}
}

export default useProductSashes
